import { render, staticRenderFns } from "./chridMenu.vue?vue&type=template&id=7c3b3794&scoped=true"
import script from "./chridMenu.vue?vue&type=script&lang=js"
export * from "./chridMenu.vue?vue&type=script&lang=js"
import style0 from "./chridMenu.vue?vue&type=style&index=0&id=7c3b3794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b3794",
  null
  
)

export default component.exports